export default {
  common: {
    enable: "تفعيل",
    notNow: "لاحقًا",
    back: "رجوع",
    cancel: "إلغاء",
    loading: "جارٍ التحميل",
  },
  registerScreen: {
    title: "شغّل متجرك\nبذكاء، وبتكلفة أقل،\nوبسرعة أعلى 100 مرة—",
    subtitle: "مع ذكاء اصطناعي یتنبأ بالخطوة التالیة",
    description:
      "Zeqi ھو مخطّطك، ومدیرك، واستراتیجیتك المدعومة بالذكاء الاصطناعي — یقلل 90٪ من تكالیف التجارة الإلكترونیة بینما یوسّع متجرك بدقة.",
    emailPlaceholder: "أدخل بريدك الإلكتروني",
    passwordPlaceholder: "أنشئ كلمة مرور",
    createAccount: "إنشاء حساب",
    alreadyHaveAccount: "ھل لدیك حساب؟",
    login: "سجّل الدخول",
    signUpGoogle: "سجّل باستخدام Google",
    signUpApple: "سجّل باستخدام Apple",
    signUpPhone: "سجّل باستخدام رقم الھاتف",
    verifyContinue: "تأكید ومتابعة",
  },
  loginScreen: {
    title: "مرحبًا بعودتك إلى Zeqi",
    subtitle: "شريكك الذكي لنمو التجارة الإلكترونية",
    description:
      "سجّل الدخول أدناه لمواصلة بناء متجرك باستخدام الذكاء الاصطناعي الذي يقلل التكاليف ويزيد المبيعات ويعمل بلا توقف.",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    login: "تسجيل الدخول",
    newTo: "جديد في Zeqi؟",
    createAccount: "إنشاء حساب",
    inviteEmailRequired: "الرجاء إدخال بريد الدعوة الخاص بك.",
    unauthorizedEmail: "بريد غير مصرح به.",
  },
  shopifyConnectScreen: {
    heroTitle: "نظام تشغيل التجارة الإلكترونية \nبالذكاء الاصطناعي",
    connectCtaSubtitle: "اتصل بنا ",
    connectCtaSubtitleBold: "ولنبدأ الآن.",
    inviteLabel: "البريد الإلكتروني",
    invitePlaceholder: "you@company.com",
    continueWithShopify: "تابع مع Shopify",
    continueWithWooCommerce: "تابع مع WooCommerce",
    currentlySupporting: "ندعم حالياً ",
    shopDomainPlaceholder: "yourstore.myshopify.com",
    termsBlurbPrefix: "بمتابعة الاستخدام، فإنك توافق على ",
    termsLink: "الشروط والأحكام",
    termsBlurbSuffix: ".",
  },

  SettingsScreen: {
    goBack: "رجوع",
    profileFallbackName: "اسم المتجر",
    profileFallbackEmail: "user@email.com",

    account: "الحساب",
    accountSettings: "إعدادات الحساب",
    connectedShop: "المتجر المتصل",
    notifications: "إعدادات الإشعارات",
    securityLogin: "الأمان وتسجيل الدخول",

    connectFacebook: "ربط فيسبوك",
    connectGoogle: "ربط جوجل",
    facebookConnected: "تم ربط فيسبوك بنجاح",
    googleConnected: "تم ربط جوجل بنجاح",
    socialAccounts: "الحسابات الاجتماعية",
    notificationsErrorTitle: "تعذّر التحديث",
    notificationsErrorMessage:
      "لم نتمكن من تحديث تفضيلات الإشعارات. حاول مرة أخرى.",
    authRequiredTitle: "يتطلب تسجيل الدخول",
    authRequiredMsg: "يرجى تسجيل الدخول لإدارة تفضيلات الإشعارات.",
    notificationsOn: "الإشعارات مفعّلة",
    notificationsOff: "الإشعارات معطّلة",
    notificationsHint: "استلم تنبيهات حول المهام والتقارير وتحديثات الحساب.",

    soon: "قريبًا",
    deleteAccount: "حذف الحساب",
    deleteAccountConfirmTitle: "حذف الحساب؟",
    deleteAccountConfirmBody:
      "سيؤدي هذا إلى حذف حسابك في Zeqi نهائيًا ثم تسجيل خروجك. لا يمكن التراجع عن هذا الإجراء.",
    deleteAccountConfirmCta: "حذف الحساب",
    deletingAccount: "جارٍ الحذف...",
    deleteAccountFailed: "تعذّر حذف الحساب الآن. حاول مرة أخرى.",
    signOut: "تسجيل الخروج",
    signOutHint: "سجّل الخروج من حسابك والعودة إلى صفحة تسجيل الدخول.",

    ai: "الذكاء الاصطناعي",
    aiSettings: "إعدادات الذكاء الاصطناعي",
    strategyProfile: "ملف الاستراتيجية",
    dataConsumption: "استهلاك البيانات",

    billing: "الفوترة",
    subscriptions: "الاشتراكات",
    billingPlan: "خطة الفوترة",
    paymentHistory: "سجل المدفوعات",

    supportFeedback: "الدعم والملاحظات",
    contactSupport: "تواصل مع الدعم",
    helpCenter: "مركز المساعدة",
    reportBug: "الإبلاغ عن خطأ",
    requestFeature: "طلب ميزة",
    requestIntegration: "طلب تكامل",

    adminPromptManager: "مدير قوالب المشغل (للمشرف)",
    language: "اللغة",

    currentSubscription: "الاشتراك الحالي:",
    currentBillingPlan: "خطة الفوترة الحالية:",
    statusLabel: "الحالة",
    weekly: "أسبوعي",
    monthly: "شهري",
    annual: "سنوي",
    noTransactions: "لا توجد سجلات دفعات متاحة.",
    unknown: "غير معروف",
    planFree: "مجاني",
    planGeneral: "عام",
    planPremium: "مميز",
    planSmsa: "SMSA",
    updateSubscription: "تحديث الاشتراك",
    refresh: "تحديث",

    // Legal
    legal: "قانوني",
    terms: "الشروط والأحكام",
    privacy: "سياسة الخصوصية",
    deleteMyData: "حذف بياناتي",
    termsSummary: "اقرأ الشروط والأحكام الخاصة بنا.",
    privacySummary: "تعرّف على كيفية جمعنا للبيانات واستخدامها.",
    deleteDataSummary: "اطلب حذف بياناتك أو تعرّف على كيفية إزالة البيانات.",
    openLink: "فتح الرابط",
  },

  NotificationScreen: {
    title: "الإشعارات",
    markAll: "تحديد الكل كمقروء",
    empty: "لا توجد إشعارات حتى الآن.",
    authRequired: "سجّل الدخول لعرض الإشعارات.",
  },

  HomeScreen: {
    notificationsPrompt:
      "هل ترغب في تمكين الإشعارات من Zeqi لتصلك التقارير والمهام وتحديثات الحساب المهمة؟",
    notificationsDeclined:
      "يمكنك تفعيل الإشعارات لاحقًا من الإعدادات متى أردت.",
  },

  OnboardingCostsModal: {
    title: "إجراء مطلوب",
    body: "قبل الانتقال إلى المرحلة التالية، أضف تكاليف المنتجات والتكاليف التشغيلية حتى يتمكن Zeqi من إكمال تقييمك.",
    productCosts: "تكاليف المنتجات",
    operatingCosts: "التكاليف التشغيلية",
    dismiss: "تخطي",
  },

  HeaderSection: {
    searchPlaceholder: "ما الذي يدور في ذهنك؟ تحدّث إليّ",
  },
  DrawerSection: {
    contactSupport: "اتصل بالدعم",
    helpCenter: "مركز المساعدة",
    reportBug: "أبلغ عن خطأ",
    requestFeature: "اطلب ميزة",
    requestIntegration: "اطلب تكاملًا",
    shopReports: "تقارير المتجر",
    productCosts: "تكاليف المنتجات",
    operatingCosts: "التكاليف التشغيلية",
  },

  HelpCenterScreen: {
    title: "مركز مساعدة Zeqi",
    faqTitle: "الأسئلة الشائعة",
    moreHelpTitle: "هل تحتاج إلى مساعدة إضافية؟",
    messageSupport: "راسل الدعم",
    noticeText:
      "يملك المستخدمون المجانيون وصولًا محدودًا. قم بالترقية لفتح المزايا المميزة.",
    faqs: {
      upgradeSubscription: {
        question: "كيف أرقّي اشتراكي؟",
        answer:
          "افتح قسم الاشتراك من الإعدادات، ثم أدخل رمزك أو اختر الخطة التي تريد ترقيتها.",
      },
      cancelSubscription: {
        question: "هل يمكنني إلغاء اشتراكي؟",
        answer:
          "نعم. انتقل إلى الاشتراك → إدارة → إلغاء. سيستمر وصولك حتى نهاية دورة الفوترة.",
      },
      applyPromoCode: {
        question: "كيف أفعّل رمز عرض أو تفعيل؟",
        answer:
          "داخل قسم الاشتراك، الصق رمزك (مثل ZEQI-PREM-XXXX) ثم اضغط تطبيق.",
      },
      resetPassword: {
        question: "كيف أعيد تعيين كلمة المرور؟",
        answer:
          "من شاشة تسجيل الدخول، اضغط «نسيت كلمة المرور» واتبع التعليمات التي تصلك بالبريد.",
      },
      multiDeviceUse: {
        question: "هل يمكنني استخدام Zeqi على عدة أجهزة؟",
        answer: "نعم. سجّل الدخول بنفس الحساب على كل جهاز.",
      },
      reportsRefresh: {
        question: "تقاريري لم تتحدّث، ماذا أفعل؟",
        answer:
          "اسحب للأسفل لتحديث شاشة التقارير. إذا استمرّت المشكلة، راسل الدعم باسم نطاق المتجر ووصفًا مختصرًا.",
      },
      dataRefreshCadence: {
        question: "كم مرة يحدّث Zeqi البيانات؟",
        answer:
          "الخطة المجانية: معاينات محدودة. العامة: تحديث حسب الطلب. المميزة: تحديثات أولوية.",
      },
      reportBugFeature: {
        question: "كيف أبلغ عن خطأ أو أطلب ميزة؟",
        answer:
          "من قائمة الأعلى، اختر «أبلغ عن خطأ» أو «اطلب ميزة»، ثم صف المشكلة أو الفكرة وأرسلها.",
      },
      dataStorage: {
        question: "هل يحتفظ Zeqi ببياناتي؟",
        answer:
          "نحتفظ فقط بما يلزم لتشغيل مساحة عملك وميزاتها. راجع سياسة الخصوصية للتفاصيل.",
      },
      voiceInput: {
        question: "الإدخال الصوتي لا يعمل.",
        answer:
          "تأكد من منح إذن الميكروفون في إعدادات جهازك، ثم جرّب مرة أخرى.",
      },
      notifications: {
        question: "لا تصلني إشعارات.",
        answer:
          "فعّل الإشعارات لتطبيق Zeqi من إعدادات النظام وداخل تفضيلات الإشعارات في Zeqi.",
      },
    },
  },

  GreetingSection: {
    greeting: "مرحبًا {{name}} 🤚🏼،",
    fallbackName: "شريكنا",
    subtitle: "راجِع التقييم.\nإذا كان كل شيء واضحًا،\nاتّبع خطة الاستراتيجية.",

    subtitleBands: {
      "0_1":
        "{{name}}، لقد ربطت Zeqi للتو. ابدأ بقراءة تقرير التقييم واقتراح الاستراتيجية.",
      "1_10":
        "بداية جميلة يا {{name}}. واصل قراءة تقرير التقييم واقتراح الاستراتيجية لتسخين استراتيجيتك.",
      "10_20": "انطلاق جميل. المكاسب الصغيرة تتراكم.",
      "20_30": "الزخم يتزايد. واصل التنفيذ.",
      "30_40": "بدأت المؤشرات الإيجابية تظهر. الاستمرارية مفتاحك.",
      "40_50": "نقترب من منتصف الطريق. التعديلات الذكية تصنع فرقًا.",
      "50_60": "تجاوزنا القمة. دفعة بسيطة تكفي.",
      "60_70": "إيقاع قوي. حسّن ما ينجح الآن.",
      "70_80": "اقتربنا كثيرًا. شدد تسعيرك وتحسينات SEO.",
      "80_90": "خطوات أخيرة. نفّذ اللمسات الحاسمة.",
      "90_100": "رائع. أنت في الأمتار الأخيرة ({{percent}}٪).",
    },

    subtitleClusters: {
      default: {
        "0_1":
          "{{name}}، لقد ربطت Zeqi للتو. ابدأ بقراءة تقرير التقييم واقتراح الاستراتيجية.",
        "1_10":
          "بداية جميلة يا {{name}}. واصل قراءة تقرير التقييم واقتراح الاستراتيجية لتسخين استراتيجيتك.",
        "10_20": "انطلاق جميل. المكاسب الصغيرة تتراكم.",
        "20_30": "الزخم يتزايد. واصل التنفيذ.",
        "30_40": "بدأت المؤشرات الإيجابية تظهر. الاستمرارية مفتاحك.",
        "40_50": "نقترب من منتصف الطريق. التعديلات الذكية تصنع فرقًا.",
        "50_60": "تجاوزنا القمة. دفعة بسيطة تكفي.",
        "60_70": "إيقاع قوي. حسّن ما ينجح الآن.",
        "70_80": "اقتربنا كثيرًا. شدد تسعيرك وتحسينات SEO.",
        "80_90": "خطوات أخيرة. نفّذ اللمسات الحاسمة.",
        "90_100": "رائع. أنت في الأمتار الأخيرة ({{percent}}٪).",
      },

      onboarding: {
        "0_1":
          "مرحبًا بك في Zeqi يا {{name}}. توجّه إلى تبويب التنفيذ (Execution Tab) واربط Google ‏(GA4، Search Console، Merchant Center) بالإضافة إلى Meta ‏(الأعمال، الإعلانات، البكسل، إنستغرام).",
        "1_10":
          "بداية قوية يا {{name}}. واصل ربط Google وMeta ليظهر كل شيء بوضوح داخل Zeqi.",
        "10_20":
          "بداية جميلة يا {{name}}. حافظ على نظافة بيانات الاعتمادات والتكاملات.",
        "20_30":
          "الزخم يتزايد. تأكد أن أساسياتك تبقى متزامنة عند {{percent}}٪.",
        "30_40":
          "بدأت المؤشرات تظهر. كن ثابتًا في اختبارات الجودة يا {{name}}.",
        "40_50":
          "نقترب من المنتصف. التعديلات الذكية الآن تجعل الأتمتة أسهل لاحقًا.",
        "50_60": "تجاوزنا القمة. ادفع قليلًا ليكتمل الإعداد عند {{percent}}٪.",
        "60_70":
          "إيقاع قوي. أبقِ فريق القيادة على اطّلاع بالصلاحيات يا {{name}}.",
        "70_80": "قاربنا النهاية. وثّق الملاحظات الأخيرة قبل {{percent}}٪.",
        "80_90":
          "بقي التدقيق والموافقات، أحكم إغلاق مرحلة الإعداد يا {{name}}.",
        "90_100":
          "اكتمل Onboarding. استعد لمرحلة Foundation Stage ({{percent}}٪).",
      },

      foundation_stage: {
        "0_1":
          "مرحبًا بك في مرحلة التقييم التأسيسي وتحليل واقع الأعمال. يجري تجهيز التقييم—عد قريبًا.",
        "1_10":
          "مرحلة الأساس بدأت يا {{name}}. سيُحدَّث التقييم مع وصول الإشارات.",
        "10_20":
          "تشكُّل الأساس جارٍ يا {{name}}. ستظهر أبرز مؤشرات التقييم قريبًا.",
        "20_30": "تقدم الأساس مستمر. ستتضح تفاصيل التقييم عند {{percent}}٪.",
        "30_40": "حركة جيدة يا {{name}}. التقييم بدأ يتبلور.",
        "40_50": "منتصف صورة الأساس. وضوح التقييم يتحسن لاحقًا.",
        "50_60": "إشارات إضافية تصل. التقييم يتحسن نحو {{percent}}٪.",
        "60_70": "زخم ثابت في مرحلة الأساس يا {{name}}. ملامح التقييم تستقر.",
        "70_80": "أنت قريب جدًا. ستكتمل أبرز نقاط التقييم قبل {{percent}}٪.",
        "80_90":
          "شارفنا على الاكتمال. مراجعات التقييم الأخيرة جارية يا {{name}}.",
        "90_100": "اكتملت صورة الأساس. التقييم جاهز عند {{percent}}٪.",
      },

      top_of_funnel: {
        "0_1":
          "{{name}}، مرحبًا في استراتيجية أعلى القمع. اضبط الحكاية قبل أن توسّع الانتشار.",
        "1_10": "بداية قوية يا {{name}}. واصل ضبط الحكاية قبل توسيع الوصول.",
        "10_20": "املأ تقويم المحتوى بعروض باردة.",
        "20_30": "ابدأ إنفاقًا خفيفًا على Meta وSearch الاستكشافي.",
        "30_40": "ادفع أصولك البطولية وتعاون مع شركاء مبكرين.",
        "40_50": "قِس أداء الإعلانات وعدّل ما لا يعمل.",
        "50_60": "وسّع الجماهير المشابهة والاهتمامات.",
        "60_70": "أضف دفعات علاقات عامة ومؤثرين لرفع الضوضاء.",
        "70_80": "اضبط صفحات الهبوط لتتوافق مع الزيارات الجديدة.",
        "80_90": "بقي تلميع CTA والنُسخ فقط.",
        "90_100":
          "آلة الوعي تعمل. حوّل التركيز إلى Middle Funnel ({{percent}}٪).",
      },

      middle_of_funnel: {
        "0_1":
          "{{name}}، أنت الآن في منتصف القمع. شكّل تجربة الإثبات من البداية.",
        "1_10":
          "بداية قوية يا {{name}}. أضف الأدلة والمقارنات والشواهد الاجتماعية.",
        "10_20": "انطلاقة جيدة يا {{name}}. أضف الأدلة والمقارنات.",
        "20_30": "الزخم يتزايد. استمر في تغذية القصص عند {{percent}}٪.",
        "30_40": "العملاء المحتملون يستمعون. كن ثابتًا يا {{name}}.",
        "40_50": "منتصف الطريق. التعديلات الذكية في الإثبات تغير القناعة.",
        "50_60":
          "التغذية وإعادة الاستهداف تعملان. ادفع قليلًا للوصول إلى {{percent}}٪.",
        "60_70": "إيقاع قوي. حسّن تقييم العملاء والتنبيهات يا {{name}}.",
        "70_80": "قاربنا اكتمال الرعاية. جهّز القمع السفلي قبل {{percent}}٪.",
        "80_90": "لمسات أخيرة قبل التسليم. واصل يا {{name}}.",
        "90_100": "منتصف القمع دافئ. حان وقت دفع نية الشراء ({{percent}}٪).",
      },

      bottom_of_funnel: {
        "0_1": "{{name}}، القمع السفلي جاهز. ابدأ بجعل تجربة الدفع مطمئنة.",
        "1_10":
          "بداية قوية يا {{name}}. ابدأ باختبار العروض وجعل عملية الدفع أكثر سلاسة.",
        "10_20": "بداية جيدة يا {{name}}. واصل اختبار العروض.",
        "20_30": "الزخم واضح. تابع عربات التسوق المتروكة عند {{percent}}٪.",
        "30_40": "الشراء قريب. اجعل الحوافز جذابة يا {{name}}.",
        "40_50": "منتصف الطريق. الدعم والأسئلة الشائعة تزيل آخر العقبات.",
        "50_60":
          "المراجعات والعاجل يعملان. ادفع قليلًا للوصول إلى {{percent}}٪.",
        "60_70": "محرك التحويل مستقر. حسّن عروض الترقية يا {{name}}.",
        "70_80":
          "أوشكنا على النهاية. اختبر العمليات وتجربة العملاء قبل {{percent}}٪.",
        "80_90": "بقي تلميع CRO فقط. أنت قادر يا {{name}}.",
        "90_100": "الدفع مضبوط. حان وقت زيادة الميزانية بثقة ({{percent}}٪).",
      },
    },
  },
  ProfileSection: {
    title: "مناطق التركيز الأساسية الحالية لديك",
    loading: "جاري تحميل مناطق التركيز…",
    loadError: "تعذّر تحميل مناطق التركيز.",
    retry: "إعادة المحاولة",
    empty: "لا توجد مناطق تركيز بعد.",

    modalTitle: "تقرير {{focusArea}} الكامل",
    modalFallbackTitle: "منطقة التركيز",
    modalSubtitle: "مناطق التركيز الأساسية الحالية لديك",
    modalNoData: "لا توجد بيانات لهذه المنطقة بعد.",

    untitledTask: "مهمة بدون عنوان",
    short: "مختصر:",
    description: "الوصف:",
    dept: "القسم:",
    assigned: "مُكلّف لـ:",
    noTasks: "لا توجد مهام بعد.",
  },
  StrategyReportSection: {
    loading: "جاري تحميل الاستراتيجية…",
    loadError: "فشل تحميل الاستراتيجية.",
    retry: "إعادة المحاولة",

    assessmentTitle: "تقرير التقييم",
    assessmentPreviewFallback:
      "نقوم بمراجعة مؤشرات متجرك الحالية لإعداد تقرير تقييم.",
    assessmentButton: "التقرير الكامل",

    strategyTitle: "مقترح الاستراتيجية",
    strategyPreviewFallback: "سيظهر مقترح الاستراتيجية هنا بمجرد توليده.",
    strategyButton: "المقترح الكامل",

    discuss: "ناقِش",
    progressLabel: "{{percent}}٪",
    modalTitle: "كامل {{title}}",
    modalSubtitleFallback: "الربحية قبل التوسع",

    cluster: "المجموعة:",
    recommended: "الموصى به:",
    research: "البحث:",
    summary: "الملخص:",
    description: "الوصف:",
    noExtra: "لا توجد محتويات إضافية بعد.",
    emptyTitleCompleted: "عمل رائع!",
    emptyBodyCompleted:
      "لقد أنهيت هذه الاستراتيجية. Zeqi تُحضّر الخطوة التالية — عد قريبًا.",
    emptyTitleWaiting: "جاري تحميل الاستراتيجية",
    emptyBodyWaiting: "نقوم بتجهيز تفاصيل الاستراتيجية.",
    generatingHangTight: "جارٍ التوليد، انتظر قليلًا.",
    assessmentTabSummary: "الملخص",
    assessmentTabFoundation: "تأسيسي",
    assessmentTabPerformance: "تحليل واقع الأعمال",
    connect: {
      title: "اربط حسابي Meta وGoogle لفتح التقارير",
      why: "تحتاج Zeqi إلى الوصول إلى بيانات الإعلانات والتحليلات لتوجيه متجرك نحو النجاح. اربط الحسابين وسنرشدك في بقية الخطوات.",
      body: "اضغط على الأزرار أدناه لربط Meta وGoogle. بعد الربط، سترافقك Zeqi في بقية الإعداد.",
      verify: {
        heading: "بعد الربط",
        meta: "ستتحقق Zeqi تلقائيًا من تدفق بيانات Meta.",
        google: "سترى تحليلاتك داخل Zeqi بمجرد إكمال الربط.",
      },
      metaCta: "ربط Meta",
      metaConnected: "مُرتبط",
      googleCta: "ربط Google",
      googleConnected: "مُرتبط",
      productCostCta: "إضافة تكاليف المنتجات",
      productCostConnected: "تمت إضافة تكاليف المنتجات",
      operatingCostCta: "إضافة التكاليف التشغيلية",
      operatingCostConnected: "تمت إضافة التكاليف التشغيلية",
      checking: "جارٍ التحقق من الاتصالات…",
      syncing:
        "انتظر قليلاً — Zeqi تقوم بمزامنة بياناتك الآن. سيستغرق الأمر لحظات قليلة.",
    },
  },
  ProblemAndResult: {
    titleProblem: "المشكلة",
    titleResearch: "البحث",
    defaultProblem:
      "نراجع الإشارات الحالية لمتجرك لتحديد السبب الجذري الأكثر احتمالًا.",
    defaultResearch:
      "نقوم بتجميع الأبحاث والمعايير ذات الصلة بمتجرك. عُد لاحقًا للاطلاع عليها.",
    viewSources: "عرض المصادر",
    // (اختياري لاحقًا)
    resultTitle: "النتيجة الموصى بها",
  },
  ZeqiLoadingModal: {
    title: "جاري إنشاء ملف Zeqi الخاص بك",
    subtitle:
      "يساعدنا هذا على معرفة المشكلة\nوحلّها باستخدام أدوات الذكاء الاصطناعي الذكية لدينا.",
    status: "جارٍ جمع المعلومات من Shopify",
  },
  ZeqiMainTab: {
    assessment: "التقييم",
    strategy: "الاستراتيجية",
    keyFocus: "التنفيذ",
    reports: "التقارير",
    chat: "الدردشة",
  },
  ZeqiKeyFocusArea: {
    header: "مجالات التنفيذ",
    tabs: { suggested: "مقترح", running: "قيد التنفيذ" },
    emptySuggested: "جارٍ توليد الإجراءات، عُد بعد قليل.",
    emptyRunning: "جارٍ توليد الإجراءات، عُد بعد قليل.",
    loadFailPrefix: "فشل التحميل:",
    tryAgain: "أعد المحاولة",
  },
  HomePage: {
    assessmentMatrix: "التقييم",
    signInTitle: "سجّل الدخول للمتابعة",
    signInPromptPrefix: "استخدم",
    signInPromptSuffix:
      "لتزويد Zeqi بمتجرك وفتح نفس لوحات التحكم الموجودة على التطبيق.",
    loginCta: "تسجيل الدخول",
    greeting: "مرحبًا {{name}}،",
    loadingShop: "جارٍ تحميل تفاصيل المتجر...",
    ownerFallback: "المتجر",
  },
  ProductCostsScreen: {
    title: "تكاليف المنتجات",
    subtitle:
      "أدخل تكلفة البضاعة (COGS) لكل منتج. قيمة 0 مقبولة إذا كانت هي التكلفة الفعلية، وتبقى رؤى الهوامش أقل دقة حتى يتم إدخال ما لا يقل عن 70٪ من التكاليف.",
    productLabel: "اسم المنتج",
    priceLabel: "السعر الحالي",
    costLabel: "تكلفة المنتج",
    saving: "جارٍ الحفظ...",
    updatePrice: "تحديث السعر",
    updateCost: "تحديث التكلفة",
    empty: "لا توجد منتجات.",
    loading: "جارٍ تحميل المنتجات...",
    loadError: "فشل تحميل تكاليف المنتجات.",
    updatePriceError: "فشل تحديث السعر.",
    updateCostError: "فشل تحديث تكلفة المنتج.",
    upload: "رفع ملف Excel",
    uploading: "جارٍ الرفع...",
    download: "تحميل القالب",
    downloadFirst: "حمّل القالب أولاً ثم قم بالرفع.",
    uploadSuccess: "تم تحديث {{updated}} وتخطي {{skipped}}.",
    uploadFailed: "فشل الرفع.",
    searchPlaceholder: "ابحث عن المنتجات",
    refresh: "تحديث",
    missingPrice: "أدخل السعر قبل التحديث.",
    idLabel: "المعرف",
  },
  OperatingCostsScreen: {
    title: "التكاليف التشغيلية",
    sub: "تتبع التغليف السنوي، الالتقاط والتخزين، الدفع عند الاستلام، والرسوم الإضافية.",
    refresh: "تحديث",
    save: "حفظ",
    saving: "جارٍ الحفظ...",
    labelRequired: "الاسم مطلوب",
    loading: "جارٍ تحميل التكاليف التشغيلية...",
    loadError: "فشل تحميل التكاليف التشغيلية.",
    saveError: "فشل حفظ التكاليف التشغيلية.",
    addError: "فشل إضافة التكلفة.",
    deleteError: "فشل حذف التكلفة.",
    annualTitle: "التكاليف التشغيلية السنوية",
    additionalTitle: "تكاليف سنوية إضافية",
    packagingFee: "رسوم التغليف",
    pickPackStorage: "الالتقاط والتغليف + التخزين",
    codFee: "رسوم الدفع عند الاستلام",
    shippingFee: "رسوم الشحن التقديرية",
    gatewayPercent: "نسبة بوابة الدفع",
    gatewayFixed: "رسوم بوابة الدفع الثابتة",
    total: "الإجمالي",
    labelPlaceholder: "الاسم",
    amountPlaceholder: "المبلغ",
    add: "إضافة",
    adding: "جارٍ الإضافة...",
    remove: "إزالة",
    emptyAdditional: "لا توجد تكاليف إضافية بعد.",
  },
  ReportsPage: {
    subtitle:
      "اطّلع على أحدث تقارير الاستراتيجية والأداء لديك. اضغط لعرض التفاصيل.",
    loading: "جارٍ تحميل التقارير...",
    loadErrorPrefix: "فشل تحميل التقارير:",
    ready: "جاهز",
    tapToView: "اضغط لعرض التقرير.",
    generating: "جارٍ الإنشاء. سيتم إشعارك.",
    reportDetails: "تفاصيل التقرير",
    labels: {
      benchmark: "لمحة عن المتجر",
      market: "تحليل سوق المتجر",
      competitor: "تحليل منافسي المتجر",
      ideation: "تقرير الأفكار الشهرية",
      seo: "تقرير SEO للمتجر",
      adsAudit: "تقرير تدقيق الإعلانات",
      influencer: "تقرير المؤثرين والترند",
      meta: "تقرير ميتا",
      google_search_console: "أداة مشرفي بحث Google",
      google_merchant_center: "مركز تاجر Google",
      revenue_reality: "تقرير واقع الإيرادات",
      yearlyContent: "تقويم الفعاليات الشهري",
      target_audience: "الجمهور المستهدف",
      historical_orders: "تقرير الطلبات التاريخية",
    },
    storeSnapshot: "لمحة عن المتجر",
  },
  AppShell: {
    chatAriaLabel: "افتح دردشة Zeqi",
    chatPlaceholder: "ما الذي يشغل بالك؟ تحدث معي",
    sideRailHome: "أمثلة:",
    sideRailAria: "إجراءات سريعة",
    rightRailAria: "الشريط الجانبي الأيمن لزيقي",
    goHomeAria: "العودة إلى الرئيسية",
    userSettings: "إعدادات المستخدم",
    collapseRail: "طي الشريط الجانبي",
    expandRail: "توسيع الشريط الجانبي",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    menuTitle: "القائمة",
    notificationsTitle: "الإشعارات",
    toggleNotifications: "تبديل الإشعارات",
    notificationFallback: "تحديث جديد",
    notificationTimeFallback: "قبل قليل",
    viewMore: "عرض المزيد",
    noNotifications: "لا توجد إشعارات جديدة.",
    chatTitle: "دردشة Zeqi",
    chatOptions: "خيارات الدردشة",
    collapseChat: "طي الدردشة",
    expandChat: "توسيع الدردشة",
    collapseRightRail: "طي لوحة الدردشة",
    expandRightRail: "توسيع لوحة الدردشة",
    chatMovedNotice: "دردشة Zeqi متاحة الآن في اللوحة اليمنى.",
  },
  TypeLabels: {
    SUPER_AGENT: "الوكيل الخارق",
    STRATEGY: "الاستراتيجية",
    PLANNING: "التخطيط",
    ANALYTICS_INSIGHTS: "التحليلات والرؤى",
    PRICING: "التسعير",
    ADVERTISING: "الإعلانات",
    CRM_EMAIL: "إدارة العلاقات والبريد",
    ORGANIC_SOCIAL: "السوشيال العضوي",
    WEB_CRO: "تحسين التحويل للموقع",
    SEO: "تحسين محركات البحث (SEO)",
    PRODUCT_INTEL: "ذكاء المنتج",
    INFLUENCER: "المؤثرون",
  },
  SuggestedScreen: {
    focusAreaFallback: "منطقة التركيز",
    actionsInFocusArea_one: "إجراء واحد في منطقة التركيز هذه",
    actionsInFocusArea_other: "{{count}} إجراءات في منطقة التركيز هذه",
  },
  SuggestedActionSection: {
    actionsHeader: "الإجراءات",
    counts: "{{s}} مقترح • {{r}} قيد التنفيذ", // still only shows مقترح + قيد التنفيذ
    runningBadge: "قيد التنفيذ",
    completedBadge: "مكتمل", // 🔥 NEW
    checkDetails: "عرض التفاصيل",
    emptySuggested: "لا توجد إجراءات مقترحة بعد.",
    emptyRunning: "لا توجد إجراءات قيد التنفيذ أو مكتملة بعد.", // clarified
    untitled: "بدون عنوان",
  },
  SelectedSuggestedActionModal: {
    actionFallback: "الإجراء",
    defaultExpectedResult: "نفّذ هذه الخطوات لتحقيق النتيجة. 🔧",
    actionPrefix: "الإجراء:",
    discuss: "ناقِش",
    runningNow: "جارٍ التنفيذ…",
    runThisTask: "نفّذ هذه المهمة",
    noTasks: "لا توجد مهام",
    untitled: "بدون عنوان",
  },
  SelectedRunningActionModal: {
    runningBadge: "قيد التنفيذ",
    completedBadge: "مكتمل",
    discuss: "ناقِش",
    defaultExpectedResult: "نفّذ هذه الخطوات للحفاظ على الزخم وتحسين الأداء.",
    untitled: "بدون عنوان",
  },
  SelectedSuggestedActionSection: {
    // dates / due
    noDueDate: "لا يوجد تاريخ استحقاق",
    invalidDate: "تاريخ غير صالح",
    overdue: "متأخر ({{days}} يوم)",
    dueToday: "مستحق اليوم",
    dueInDays: "مستحق خلال {{days}} يوم",
    dueOnDate: "مستحق في {{date}}",

    // chips
    aiTask: "مهمة الذكاء الاصطناعي",
    userTask: "مهمة {{who}}",
    user: "المستخدم",
    runAll: "نفّذ الكل",

    // header & fallback
    expectedResultTitle: "النتيجة المتوقعة",
    expectedResultFallback: "نفّذ هذا الإجراء لتحريك المؤشر الذي نهتم به.",
    tasks_one: "مهمة واحدة",
    tasks_other: "{{count}} مهام",
    untitledTask: "مهمة بدون عنوان",

    // buttons & states
    completed: "مكتملة",
    running: "قيد التنفيذ",
    markAsDone: "وضع علامة مكتمل",
    cannotComplete: "لا يمكن إكمالها",
    needsApproval: "تحتاج موافقة",
    aiOwnedTask: "مهمة مملوكة للذكاء الاصطناعي",

    // alerts
    notAllowedTitle: "غير مسموح",
    notAllowedMsg: 'لا يمكن إكمال المهام إلا إذا كانت مخصصة لـ "المستخدم".',
    notApprovedTitle: "غير معتمد",
    notApprovedMsg: "يجب اعتماد هذه المهمة قبل إكمالها.",
    completeErrorTitle: "تعذّر إكمال المهمة",
    unknownError: "خطأ غير معروف",

    // Skip
    skipConfirmTitle: "تخطي هذه المهمة؟",
    skipConfirmMessage:
      "سيتم وضع علامة على المهمة كمكتملة وسيقوم زيكي بتخطيها.",
    skipReasonPrompt: "يرجى توضيح سبب تجاهل هذه المهمة.",
    skipReasonPlaceholder: "اكتب السبب...",
    skipReasonRequired: "السبب مطلوب لتجاهل هذه المهمة.",
    skip: "تجاهل المهمة",
    skipped: "تم تجاهلها",
  },
  ZeqiChatModal: {
    title: "دردشة Zeqi",
    placeholder: "اكتب رسالتك...",
    noAction: "لم يتم العثور على إجراء. جرّب فتح الدردشة من بطاقة إجراء.",
    startConversation: "ابدأ محادثة مع Zeqi...",
    untitledTask: "مهمة بدون عنوان",
    defaultRunPrompt: "نفّذ هذه المهمة.",
    defaultDiscussPrompt: "دعنا نناقش هذه المهمة.",
  },
  TextInputTaskModal: {
    // headers
    tasks: "المهام",
    running: "قيد التنفيذ",
    otherTasks: "مهام أخرى",

    // empties
    noRunning: "لا توجد مهام قيد التنفيذ حاليًا.",
    noOther: "لا توجد مهام أخرى في الوقت الحالي.",

    // chips / status
    automatedAI: "مؤتمت (ذكاء اصطناعي)",
    assignedToUser: "مُسندة إلى المستخدم",
    suggested: "مقترح",
    completed: "مكتملة",
    runningEllipsis: "جارٍ التنفيذ…",
    runThisTask: "نفّذ هذه المهمة",
    discuss: "ناقِش",
    // due labels
    noDueDate: "لا يوجد تاريخ استحقاق",
    invalidDate: "تاريخ غير صالح",
    overdue: "متأخر ({{days}} يوم)",
    dueToday: "مستحق اليوم",
    dueTomorrow: "مستحق غدًا",
    dueInDays: "مستحق خلال {{days}} يوم",

    // misc
    untitledTask: "مهمة بدون عنوان",
  },
  GoogleConnectScreen: {
    headerTitle: "الاتصال بـ Google",
    title: "وصّل حسابك في Google",
    // NEW
    subtitleDual:
      "اربط Google لتفعيل مسارين:\n• قابلية الاكتشاف في Google (GA4 + GSC)\n• جاذبية النقر (تشخيص CTR والمخططات والعناوين).",
    connectFindability: "اربط Google",
    connectingFindability: "جارٍ الربط…",
    connectClickAttraction: "الاتصال — جاذبية النقر",
    connectingClick: "جارٍ الاتصال بجاذبية النقر…",

    // existing:
    connect: "الاتصال عبر Google",
    subtitle:
      "اربط Google Analytics ‏(GA4) لجلب بيانات الزيارات والتحويلات لمتجرك.",
    connecting: "جارٍ الاتصال…",
    fetchingProps: "جارٍ جلب خصائص GA4…",
    tip: "تأكد من تثبيت خاصية GA4 على متجرِك واستلامها للبيانات للحصول على أدقّ الرؤى.",
    oauthUserMissing: "لم يتم تحميل المستخدم بعد.",
    checkingConnection: "جارٍ التحقق من الاتصال...",
    oauthError: "تعذّر إكمال تسجيل الدخول إلى Google.",
    authMissing: "الرمز المميّز مفقود. يُرجى تسجيل الدخول مجددًا.",
    noPropsTitle: "لا توجد خصائص GA4",
    noPropsBody:
      "لم نعثر على أي خصائص GA4 في حساب Google الخاص بك.\n\nتأكد من:\n• استخدامك خاصية GA4 (وليس UA)\n• امتلاكك صلاحية «مشاهد» على تلك الخاصية",

    // NEW (used when auto-triggering the report)
    creatingInitialEngagement: "جارٍ إنشاء تقرير التفاعل الأولي…",
    initialEngagementReady: "تم إنشاء تقرير التفاعل الأولي.",
    connected: "متصل بـ Google",
  },

  // Arabic
  MetaConnectScreen: {
    headerTitle: "الاتصال بـ Meta",
    title: "وصّل حساب أعمالك على Meta",
    subtitle:
      "لأفضل تجربة، تأكد من ربط «بكسل ميتا» وحساب إنستغرام بالحساب التجاري نفسه على Meta قبل المتابعة.",
    // kept for backward compatibility:
    connect: "الاتصال عبر Meta",

    // NEW:
    connectFacebook: "الاتصال عبر Meta",
    connectInstagram: "الاتصال عبر Instagram",
    tip: "تحقّق من أن مدير أعمال Meta مفعل، وأن لديك الأذونات المطلوبة، وأن «البكسل» وحساب إنستغرام مضافان/مرتبطان تحت ذلك الحساب التجاري.",
    oauthUserMissing: "لم يتم تحميل المستخدم بعد.",
    connecting: "جارٍ الاتصال...",
    checkingConnection: "جارٍ التحقق من الاتصال...",
    oauthError: "حدث خطأ أثناء تسجيل الدخول إلى فيسبوك.",
    errorTitle: "خطأ",
    connected: "متصل بـ Meta",
  },
  ShopReportsScreen: {
    title: "تقارير المتجر",
    subtitle:
      "اطّلع على أحدث تقارير الاستراتيجية والأداء. استخدم التحديث لإعادة التوليد عند الحاجة.",
    benchmark: "تقرير قياس أداء المتجر",
    market: "تحليل سوق المتجر",
    competitor: "تحليل المنافسين للمتجر",
    ideation: "تقرير الأفكار الشهري",
    seo: "تقرير تحسين محركات البحث",
    adsAudit: "تقرير تدقيق الإعلانات",
    influencer: "تقرير المؤثرين والاتجاهات",
    initialEngagement: "تقرير التفاعل المبدئي",
    alignment: "تقرير التوافق مع النية",
    clickAttraction: "تقرير جذب النقرات",
    brandRecall: "تقرير استدعاء العلامة التجارية",
    lightEngagement: "تقرير التفاعل البسيط",
    shopOrganicVisibility: "تقرير الظهور العضوي للمتجر",
    open: "فتح",
    refresh: "تحديث",
    itemHint: "اضغط فتح للعرض، تحديث لإعادة التوليد.",
  },
  SubscriptionPlanScreen: {
    title: "الاشتراك",
    yourPlan: "خطتك الحالية",
    statusLabel: "الحالة",
    activeBadge: "مفعلة",
    premiumTier: "فئة بريميوم",
    haveCode: "هل لديك رمز؟",
    codeHelp: "أدخل رمز التفعيل أو العرض الترويجي أدناه لتطبيق الخطة.",
    placeholder: "مثال: ZEQI-PREM-XXXX",
    apply: "تطبيق",
    applying: "جارٍ التطبيق...",
    detected: "الخطة المكتشفة",
    plans: "الخطط",
    selected: "مُختارة",
    choose: "اختر",
    viewDetails: "عرض التفاصيل",
    alreadyActive: "مفعلة بالفعل",
    alreadyActiveMsg: "أنت بالفعل على هذه الخطة.",
    comingSoon: "قريباً",
    invalid: "غير صالح",
    invalidMsg: "يرجى إدخال رمز.",
    notRecognized: "غير معروف",
    notRecognizedMsg: "هذا الرمز غير صالح أو منتهي الصلاحية.",
    success: "نجاح",
    successMsg: "تم تطبيق الرمز بنجاح.",
    failed: "فشل",
    failedMsg: "تعذر تطبيق الرمز. حاول مرة أخرى.",
    checkoutFailedMsg: "تعذّر بدء عملية الدفع. يرجى المحاولة مرة أخرى.",
    checkoutStartedTitle: "تم فتح الدفع",
    checkoutStartedMsg:
      "أكمل عملية الدفع في المتصفح. سيتم تحديث خطتك تلقائيًا بمجرد تأكيد Stripe.",
    genericSuccessMsg: "تم تفعيل {{plan}} بنجاح.",
    notice: "تنبيه",
    unsupportedCode: "هذا الرمز غير مدعوم بعد. يرجى التواصل مع الدعم.",
    authRequiredTitle: "يتطلب تسجيل الدخول",
    authRequiredMsg: "يرجى ربط متجرك أو تسجيل الدخول قبل إدارة الاشتراكات.",
    cancelConfirmTitle: "إلغاء الاشتراك؟",
    cancelConfirmMsg:
      "هل أنت متأكد من رغبتك في إلغاء الاشتراك المدفوع؟ سيظل وصولك متاحًا حتى نهاية دورة الفوترة الحالية.",
    keep: "استمرار",
    cancelNow: "إلغاء الآن",
    cancelSuccess: "تم إلغاء الاشتراك",
    cancelSuccessMsg:
      "تم إلغاء اشتراكك. سيبقى الوصول متاحًا حتى نهاية دورة الفوترة الحالية.",
    cancelFailed: "تعذر الإلغاء",
    cancelFailedMsg: "لم نتمكن من إلغاء الاشتراك. يرجى المحاولة مرة أخرى.",
    planFree: "مجاني",
    planSmsa: "SMSA",
    planGeneral: "عام",
    planPremium: "مميز",
    status: {
      ACTIVE: "مفعّل",
      TRIALING: "فترة تجريبية",
      PAST_DUE: "متأخر في الدفع",
      UNPAID: "غير مدفوع",
      INCOMPLETE: "غير مكتمل",
      INCOMPLETE_EXPIRED: "غير مكتمل منتهي",
      CANCELED: "ملغى",
      PAUSED: "موقوف مؤقتًا",
    },
    planDetails: {
      modalTitle: "خطة {{plan}}",
      close: "إغلاق",
      priceLabel: "السعر",
      billingLabel: "الفوترة",
      includesLabel: "ما الذي يتضمنه",
      bestForLabel: "مثالية لـ",
      notesLabel: "معلومات مهمة",
      free: {
        tagline: "ثبّت أساس Zeqi قبل الالتزام.",
        price: "تجربة مجانية",
        billing: "تجربة لمدة 10 أيام بدون بطاقة.",
        includes: [
          "رسالتان يوميًا عبر Zeqi Chat للأسئلة السريعة.",
          "قائمة إعداد ذكية تغطي الفهرسة، التغذية، والسياسات.",
          "تقرير تقييم تلقائي مع أولويات التنفيذ.",
          "موجز يومي من Zeqi بأفضل خطوة تالية.",
        ],
        bestFor: [
          "التجار الذين يربطون Zeqi للمرة الأولى.",
          "الفرق التي تتحقق من الأساسات قبل الترقية لخطة مدفوعة.",
        ],
        notes: ["بعد 10 أيام يمكنك الترقية إلى General أو Premium وقتما تشاء."],
      },
      smsa: {
        tagline: "برنامج ممول بالشراكة مع SMSA لإطلاق النمو واللوجستيات.",
        price: "$270/شهريًا (مغطّى من SMSA لمدة 6 أشهر)",
        billing:
          "أدخل الرمز الترويجي عند الدفع. ستدفع 0$ لمدة 6 أشهر، ثم 270$ شهريًا.",
        includes: [
          "فتح جميع مشغلات أتمتة Premium لمدة 6 أشهر.",
          "تدقيق جاهزية اللوجستيات من SMSA مع خدمة كونسييرج للشركاء.",
          "مراجعات استراتيجية شهرية مع توجيه مُرتَّب للأولويات.",
        ],
        bestFor: [
          "العلامات التجارية التي تشحن عبر SMSA وتريد بداية ممولة بالشراكة.",
          "الفرق التي تحتاج إلى رؤية لوجستية بالإضافة إلى أتمتة للنمو.",
        ],
        notes: [
          "استخدم الرمز الترويجي عند الدفع لتفعيل تغطية الأشهر الستة.",
          "بعد النافذة الترويجية، تستمر الفوترة شهريًا بسعر خطة Premium.",
        ],
      },
      general: {
        tagline: "إرشاد ثابت من الذكاء الاصطناعي دون تنفيذ كامل.",
        price: "$27/شهريًا",
        billing: "يتم الفوترة شهريًا ويمكن الإلغاء في أي وقت.",
        includes: [
          "خمس رسائل يومية مع Zeqi Chat لحل الأسئلة الاستراتيجية.",
          "تحديث التقارير الاستراتيجية الأساسية كل شهر.",
          "أتمتة لمهام الأساس والخطة العامة.",
          "دعم عبر البريد الإلكتروني خلال 48 ساعة.",
        ],
        bestFor: [
          "المتاجر التي تحتاج إلى إرشاد ثابت من Zeqi.",
          "الفرق التي أنهت التجربة المجانية وتبحث عن خطوات مدفوعة خفيفة.",
        ],
        notes: [
          "خيار مثالي للتجار الذين يريدون توجيه Zeqi مع تنفيذ خفيف الوزن.",
        ],
      },
      premium: {
        tagline: "تنفيذ كامل مدعوم بـ Zeqi عبر كل القنوات.",
        price: "تسعير شرائح يبدأ من 270$/شهريًا",
        billing:
          "يتم الفوترة شهريًا. تتغير الشريحة تلقائيًا بناءً على عدد المنتجات النشطة.",
        includes: [
          "تحديثات غير محدودة للتقارير والأتمتة في جميع المجموعات.",
          "حزم استخبارات المنتجات، الحملات، والاحتفاظ.",
          "دعم أولوية مع مشغّل ذكاء اصطناعي مخصص.",
        ],
        bestFor: [
          "الفرق التي توسّع المنتجات، الإعلانات، وبرامج الولاء بسرعة.",
          "العلامات التجارية التي تريد Zeqi لتنفيذ الاستحواذ والاحتفاظ والتسعير.",
        ],
        notes: [
          "الفئة 1: 270$/شهر حتى 50 منتجًا نشطًا.",
          "الفئة 2: 280$/شهر حتى 100 منتج نشط.",
          "الفئة 3: 300$/شهر حتى 200 منتج نشط.",
          "الفئة 4: 320$/شهر لأكثر من 200 منتج نشط.",
        ],
      },
    },
  },
  ReportBugModal: {
    title: "الإبلاغ عن خطأ",
    emailLabel: "بريدك الإلكتروني",
    emailPlaceholder: "you@company.com",
    messageLabel: "صف الخطأ",
    messagePlaceholder: "ماذا حدث؟ هل توجد خطوات لإعادة المشكلة؟",
    send: "إرسال",
    sending: "جارٍ الإرسال…",
    invalidEmail: "يرجى إدخال بريد إلكتروني صالح.",
    shortMsg: "يرجى إضافة مزيد من التفاصيل (5 أحرف على الأقل).",
    toast: "شكرًا على الإبلاغ! سيتولى فريقنا المراجعة والحل خلال 24–48 ساعة.",
  },

  RequestFeatureModal: {
    title: "طلب ميزة",
    emailLabel: "بريدك الإلكتروني",
    emailPlaceholder: "you@company.com",
    messageLabel: "ما الذي تودّ أن نبنيه؟",
    messagePlaceholder: "صف الميزة ولماذا تفيدك…",
    send: "إرسال",
    sending: "جارٍ الإرسال…",
    invalidEmail: "يرجى إدخال بريد إلكتروني صالح.",
    shortMsg: "يرجى إضافة مزيد من التفاصيل (5 أحرف على الأقل).",
    toast: "شكرًا! سيقوم فريقنا بمراجعة طلبك والرد خلال 24–48 ساعة.",
  },

  RequestIntegrationModal: {
    title: "طلب تكامل",
    emailLabel: "بريدك الإلكتروني",
    emailPlaceholder: "you@company.com",
    messageLabel: "ما التكامل الذي تحتاجه؟",
    messagePlaceholder:
      "أخبرنا بالمنصة أو الأداة التي تريد أن يدعمها Zeqi وكيف تخطط لاستخدامها…",
    send: "إرسال",
    sending: "جارٍ الإرسال…",
    invalidEmail: "يرجى إدخال بريد إلكتروني صالح.",
    shortMsg: "يرجى إضافة مزيد من التفاصيل (5 أحرف على الأقل).",
    toast: "شكرًا! سيقوم فريقنا بمراجعة طلب التكامل والرد خلال 24–48 ساعة.",
  },

  ContactSupportModal: {
    title: "التواصل مع دعم Zeqi",
    emailLabel: "بريدك الإلكتروني",
    emailPlaceholder: "you@company.com",
    messageLabel: "كيف يمكننا مساعدتك؟",
    messagePlaceholder: "اكتب رسالتك…",
    send: "إرسال",
    sending: "جارٍ الإرسال…",
    invalidEmail: "يرجى إدخال بريد إلكتروني صالح.",
    shortMsg: "يرجى إضافة مزيد من التفاصيل (5 أحرف على الأقل).",
    toast: "شكرًا لك! سنتواصل معك خلال 24–48 ساعة عبر البريد الذي قدمته.",
  },

  AuthCallbackPage: {
    authenticating: "جاري التحقق من الهوية...",
  },
  ChatPage: {
    invalidFileMsg:
      "يرجى اختيار صورة صالحة أو ملف PDF بحجم أقل من 10 ميغابايت.",
    signInRequired: "يرجى تسجيل الدخول للدردشة مع Zeqi.",
    typeMessage: "اسأل Zeqi أي شيء...",
  },
  // Add more screens...
};
